import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router } from '@angular/router';
import { CONSTANTS } from '../../constants';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [
    trigger('slide', [
      state('up', style({ height: 0 })),
      state('down', style({ height: '*' })),
      transition('up <=> down', animate(200))
    ])
  ]
})
export class SidebarComponent implements OnInit {

  admin: any;
  username: any;
  
  menus: any = {};
  selected_page = "users";

  constructor(private dataService: DataService, private router: Router) { }

  ngOnInit() {
    // this.jq.initializeMenu();
    this.username = sessionStorage.getItem(CONSTANTS.COOKIE.USERNAME);
    this.admin = sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN);
    this.dataService.onPageLoaded.subscribe(data => {
      this.selected_page = data.name;
      if (this.selected_page == CONSTANTS.URI_PATH.REPORT_ALERTS) {
        this.menus[CONSTANTS.URI_PATH.REPORT].collapsed = false;
      }
    });
    this.init_menu_states();
    $(".nav-toggle-icon").on("click", function() {
      $(".wrapper").toggleClass("toggled")
    })

    $(".mobile-toggle-icon").on("click", function() {
      $(".wrapper").addClass("toggled")
    })

    $(".toggle-icon").click(function() {
      $(".wrapper").hasClass("toggled") ? ($(".wrapper").removeClass("toggled"), $(".sidebar-wrapper").unbind("hover")) : ($(".wrapper").addClass("toggled"), $(".sidebar-wrapper").hover(function() {
        $(".wrapper").addClass("sidebar-hovered")
      }, function() {
        $(".wrapper").removeClass("sidebar-hovered")
      }))
    })
  }

  init_menu_states() {
    this.menus[CONSTANTS.URI_PATH.DASHBOARD] = { collapsible: false, collapsed: false };
    this.menus[CONSTANTS.URI_PATH.USERS] = { collapsible: false, collapsed: false };
    this.menus[CONSTANTS.URI_PATH.BROKERS] = { collapsible: false, collapsed: false };
    this.menus[CONSTANTS.URI_PATH.THREAD] = { collapsible: false, collapsed: false };
    this.menus[CONSTANTS.URI_PATH.ORDER_POS] = { collapsible: false, collapsed: false };
    this.menus[CONSTANTS.URI_PATH.TRADEBOARD] = { collapsible: false, collapsed: false };
    this.menus[CONSTANTS.URI_PATH.CHANNEL] = { collapsible: false, collapsed: false };
    this.menus[CONSTANTS.URI_PATH.REPORT] = { collapsible: true, collapsed: true };
    this.menus[CONSTANTS.URI_PATH.ENTITY] = { collapsible: true, collapsed: true };
    this.menus[CONSTANTS.URI_PATH.DATA_COLLECTION] = { collapsible: false, collapsed: false };
    this.menus[CONSTANTS.URI_PATH.LOGS] = { collapsible: false, collapsed: false };
    this.menus[CONSTANTS.URI_PATH.SETTINGS] = { collapsible: false, collapsed: false };
  }

  activeClass(name: any) {
    if (this.selected_page == name) {
      return { 'mm-active': 1 };
    }
    return { 'mm-active': 0 };
  }

  showClass(name: any) {
    if (this.menus[name].collapsible) {
      if (this.menus[name].collapsed) {
        return { 'mm-collapse': 1 };
      } else {
        return { 'mm-show': 1 };
      }
    }
    return { 'mm-show': 1 };
  }

  getState(currentMenu: any) {
    if (currentMenu.active) {
      return 'down';
    } else {
      return 'up';
    }
  }

  get_base_path() {
    let path = CONSTANTS.URI_PATH.CLIENT;
    if (this.admin == 'true') {
      path = CONSTANTS.URI_PATH.TAH;
    }
    return path;
  }

  route(menu: any) {
    let base_path: any = `/${this.get_base_path()}`;
    this.router.navigate([base_path, menu]);
  }

  onMenuClicked(name: any) {
    if (this.menus[name].collapsible) {
      this.menus[name].collapsed = !this.menus[name].collapsed;
    }
  }
}
